import { ApiEndpoints, GlobalConstants } from "../../../utils/app-constants";
import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../utilities/list-header";
import { PageData } from "../../utilities/paged-request";

export class InvoiceSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.ACCOUNTING_INVOICES_QUERY;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('', ''),
            new ListColumn('Invoice ID', ''),
            new ListColumn('Type', ''),
            new ListColumn('Date', ''),
            new ListColumn('Dealer', ''),
            new ListColumn('Amount', ''),
            new ListColumn('Download', '')
        ];

        // Create our Filter Groups
        const byDate        = this.buildInvoiceDate();
        const byInvoiceID   = this.buildInvoiceID();
        const byOrderID     = this.buildOrderID();
        const byTruckID     = this.buildTruckID();
        const byDealer      = this.buildDealer();
        
        this.filters.push(
            byDate, byInvoiceID, byOrderID, byTruckID, byDealer
        );

    }

    // #region Group Builders

    private buildInvoiceID() {
        const byInvoice = new FilterGroup('Invoice ID', 'numeric', 'id');
        const opt1 = new FilterBarInputOpt('Invoice ID', '');
        
        byInvoice.opts = [opt1];

        return byInvoice;
    }

    private buildOrderID() {
        const byOrder = new FilterGroup('Order ID', 'text', 'order');
        const opt1 = new FilterBarInputOpt('Order ID', '');
        
        byOrder.opts = [opt1];

        return byOrder;
    }

    private buildTruckID() {
        const byTruck = new FilterGroup('Truck ID', 'text', 'shipment');
        const opt1 = new FilterBarInputOpt('Truck ID', '');
        
        byTruck.opts = [opt1];

        return byTruck;
    }    
    
    private buildInvoiceDate() {
        const byDate = new FilterGroup('Invoice Date', 'date', 'date');        
        const opt1 = new FilterBarInputOpt('Invoice Date', new Date());
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealer');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    // #endregion

}
